import { useQuery, type QueryFunction, type QueryKey } from '@tanstack/react-query';

export type UsePaginatedQueryArgs<TQueryFnData, TQueryKey extends QueryKey> = {
    enabled: boolean;
    queryKey: TQueryKey;
    queryFn: QueryFunction<TQueryFnData, TQueryKey>;
};

export function usePaginatedQuery<TQueryFnData, TQueryKey extends QueryKey>(
    args: UsePaginatedQueryArgs<TQueryFnData, TQueryKey>
) {
    return useQuery({
        queryKey: args.queryKey,
        queryFn: args.queryFn,
        enabled: args.enabled
    });
}
